import deepmerge from 'deepmerge';

const baseOptions = {
  headers:{
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  credentials: 'include',
};

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {Promise}         A promise that resolves to the parsed JSON
 */
function parseJSON(response) {
  if (response.json) return response.json();

  return Promise.resolve(null);
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  // For error responses, throw an error to trigger the catch block
  const error = new Error(response.statusText || `HTTP Error ${response.status}`);
  error.response = response;
  error.status = response.status;
  throw error;
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(url, options) {
  // const opt = {...baseOptions, ...options};
  const opt = deepmerge(baseOptions, options);

  // Use window.fetch to ensure we're using the global fetch, not a local variable
  const fetchFn = (typeof window !== 'undefined' && window.fetch) || fetch;

  return fetchFn(url, opt)
    .then(checkStatus)
    .then(parseJSON)
    .catch((err) => {
      // Try to parse error response body for more details
      if (err && err.response) {
        return parseJSON(err.response).then((body) => {
          if (body) {
            err.responseBody = body;
          }
          throw err;
        }).catch(() => {
          // If body parsing fails, just rethrow the original error
          throw err;
        });
      }
      throw err;
    });
}
